'use client';

import { useEffect, useState } from 'react';

import { shouldEnableMarketingTags } from '@/lib/tracking/marketing-tags';

/**
 * True after hydration when marketing tags are allowed (env + live host).
 * Starts false so SSR HTML and the first client render match.
 */
export function useMarketingTagsEnabled(): boolean {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(shouldEnableMarketingTags());
  }, []);

  return enabled;
}
